import { render, staticRenderFns } from "./ThreeDViewer.vue?vue&type=template&id=7bf12cba&scoped=true"
import script from "./ThreeDViewer.vue?vue&type=script&lang=ts"
export * from "./ThreeDViewer.vue?vue&type=script&lang=ts"
import style0 from "./ThreeDViewer.vue?vue&type=style&index=0&id=7bf12cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf12cba",
  null
  
)

export default component.exports